global.jQuery = require("jquery");

// Polyfill for $.type() which was removed in jQuery 4.0
// Required for slick-carousel compatibility
(function($) {
    if (typeof $.type === 'undefined') {
        var class2type = {};
        var toString = class2type.toString;
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(function(name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });
        $.type = function(obj) {
            if (obj == null) {
                return obj + "";
            }
            return typeof obj === "object" || typeof obj === "function" ?
                class2type[toString.call(obj)] || "object" :
                typeof obj;
        };
    }
})(global.jQuery);

require("bootstrap");
require("slick-carousel/slick/slick.js");
require("./app/hero-slider");
require("./app/responsive-bk-img.js");
require("./app/responsive-product-overview-img-source");
require("./app/responsive-product-hero-img");
require("./app/responsive-product-img");
require("./app/image-carousel");
require("./app/key-features-slider");
require("./app/tab-slider");
require("./app/form-btn");
require("./app/video-block");
require("./app/panel-container");
require("./app/iframe-block");
require("./app/sitesearch");
require("./app/banners");
require("./app/link-popup");
require("./app/events-filter");
require("./app/data-filter");
require("./app/documents-filter");
require("./app/animated-multi-slide");
require("./app/calculator-modal");
require("./app/message-modal-container");
require("./app/moneris-payment");
require("./app/country-flags-lazy");
require("./app/conmed-engage");

// play button
(function ($) {
    global.$ = $;
    $(document).ready(function () {

        conmed.heroSlider.init();
        conmed.imageCarousel.init();
        conmed.keyFeatures.init();
        conmed.responsive_bk_img.init();
        conmed.responsive_product_overview_img_source.init();
        conmed.responsive_product_hero_img.init();
        conmed.responsive_product_img.init();
        conmed.tabSliders.init();
        conmed.formBtn.init();
        conmed.videoBlock.init();
        conmed.panelContainer.init();
        conmed.iframeBlock.init();
        conmed.sitesearch.init();
        conmed.banners.init();
        conmed.linkPopup.init();
        conmed.eventsFilter.init();
        conmed.dataFilter.init();
        conmed.animatedMultiSlide.init();
        conmed.calculatorModal.init();
        conmed.messageModalContainer.init();
        conmed.monerisPayment.init();
        conmed.countryFlagsLazy.init();
       
        $('[data-bs-toggle="popover"]').popover({
            trigger: "hover" 
        });

        $('#countryDropdown a.country-selected').click(function () {
            var selectedOption = $(this).html();
            $('.country-menu').html(selectedOption);
        });

        $('#langDropdown a.language-selected').click(function () {
            var selectedOption = $(this).html();
            $('.language-menu').html(selectedOption);
        });

        $(".wistia-transcript").css("display", "none");
       

        if ($(window).width() < 992) {
            var savedMenu = '';
            $('.navbar-toggler').click(function (e) {
                $('#menuReplacement').empty();
                $('.primary-navbar').show();
                $('.secondary-navbar').show();
                $('.language-navbar').show();
            });

            $('.accordion-item').click(function (e) {
                if (e.target.className.includes('accordion-item')) {
                    var cloned = $(this).clone(true);
                    cloned.children('.accordion-header').addClass('menu-level');
                    $('#menuReplacement').empty();
                    $('#menuReplacement').append(cloned);
                    $('.primary-navbar').hide();
                    $('.secondary-navbar').hide();
                    $('.language-navbar').hide();
                    savedMenu = cloned;
                }
            });

            $('.flag-header-div').click(function (e) {
                var cloned = $(this).clone(true);
                cloned.children('.country-main').children('.accordion-header').addClass('menu-level');
                $('#menuReplacement').empty();
                $('#menuReplacement').append(cloned);
                $('#menuReplacement').addClass('sub-menu-country');
                savedMenu = cloned;
            });
        }
        else {
            var saved = '';
            $('.language-navbar').click(function (e) {
                var cloned = $('.language-list').clone(true);
                $('#menuReplacementDesktop').empty();
                $('#menuReplacementDesktop').append(cloned);
                $('#menuReplacementDesktop').removeClass('selected');
                $('#menuReplacementDesktop').removeClass('sub-menu-country');
                $('.accordion-collapse').removeClass('show');
                $('.accordion-button').addClass('collapsed');
                $('.secondary-nav-lg-div').attr("style", "display:none !important");
                $('#menuReplacementDesktop').show(500);
                saved = cloned;
            });

            countryClick();
            regionClick();
            closeClick();

            function regionClick() {
                $('.region .accordion-item').click(function (e) {
                    var cloned = $(this).clone(true);
                    cloned.children('.accordion-header').addClass('menu-level');
                    $('#menuReplacementDesktop').empty();
                    $('#menuReplacementDesktop').append(cloned);
                    $('#menuReplacementDesktop').addClass('sub-menu');
                    $('#menuReplacementDesktop').removeClass('dismiss').addClass('selected');
                    menuClick();
                    closeClick();
                });
            }

            function countryClick() {
                $('.country-main').click(function (e) {
                    var cloned = $(this).clone(true);
                    cloned.children('.accordion-header').addClass('menu-level');
                    $('#menuReplacementDesktop').empty();
                    $('#menuReplacementDesktop').append(cloned);
                    $('#menuReplacementDesktop').removeClass('sub-menu');
                    $('#menuReplacementDesktop').addClass('sub-menu-country');
                    $('#menuReplacementDesktop').removeClass('selected').addClass('selectedCountry');
                    menuClick();
                    closeClick();
                });
            }
            function menuClick() {
                $('.menu-level').click(function (e) {
                    $('#menuReplacementDesktop').empty();
                    $('#menuReplacementDesktop').append(saved);
                    $('#menuReplacementDesktop').removeClass('selected');
                    $('.accordion-collapse').removeClass('show');
                    $('.accordion-button').addClass('collapsed');
                    $('#menuReplacementDesktop').removeClass('sub-menu');
                    $('#menuReplacementDesktop').removeClass('sub-menu-country');
                    regionClick();
                    countryClick();
                    closeClick();
                });
            }

            function closeClick() {
                $('.close-lang').click(function (e) {
                    $('#menuReplacementDesktop').removeClass('selected');
                    $('#menuReplacementDesktop').hide(500);
                    $('.accordion-collapse').removeClass('show');
                    $('.accordion-button').addClass('collapsed');
                    $('.secondary-nav-lg-div').attr("style", "display:flex !important; flex-wrap:wrap");
                });
            }            
        }


        //$(".country-item").click(function (e) {
        //    e.preventDefault();           
        //    // get the data attributes
        //    var countryId = $(this).data('country');
        //    //var url = $(this).data('href');

        //    $.ajax({
        //        type: 'POST',
        //        url: '/webapi/setcurrentcountry?requestedCountry=' + countryId,
        //        success: function (data) {
        //            window.location.reload();
        //        },
        //        error: function (XMLHttpRequest, textStatus, errorThrown) {
        //            console.log("error: " + textStatus + " " + errorThrown);
        //        }
        //    });
            
        //})


        if ($(".events-docs-container-section").length > 0) {

            var procedure = getQueryVariable(window.location.href, "procedure");

            if (procedure !== false && procedure !== 'undefined')
                $('#procedure').val(procedure);

            var anatomy = getQueryVariable(window.location.href, "anatomy");

            if (anatomy !== false && anatomy !== 'undefined')
                $('#anatomy').val(anatomy);

            var publication = getQueryVariable(window.location.href, "publication");

            if (publication !== false && publication !== 'undefined')
                $('#publication').val(publication);

            var year = getQueryVariable(window.location.href, "year");

            if (year !== false && year !== 'undefined')
                $('#year').val(year);

            var region = getQueryVariable(window.location.href, "region");

            if (region !== false && region !== 'undefined')
                $('#region').val(region);

            var eventTypes = getQueryVariable(window.location.href, "eventtype");

            if (eventTypes !== false && eventTypes !== 'undefined') {
                $('#eventtype').val(eventTypes);
            }

            var resourceType = getQueryVariable(window.location.href, "resourcetype");

            if (resourceType !== false && resourceType !== 'undefined') {
                $('#resourcetype').val(resourceType);
            }

            var specialties = getQueryVariable(window.location.href, "specialties");

            if (specialties !== false && specialties !== 'undefined')
                $('#specialties').val(specialties);

            var roles = getQueryVariable(window.location.href, "roles");

            if (roles !== false && roles !== 'undefined')
                $('#roles').val(roles);

            var tags = getQueryVariable(window.location.href, "tags");

            if (tags !== false && tags !== 'undefined')
                $('#tags').val(tags);
            
        }

        function getQueryVariable(url, variable) {

            var query = url.split('?')[1];

            var vars = query.split('&');

            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (pair[0] == variable) {
                    return pair[1];
                }
            }

            return false;
        }
    
    });


})(global.jQuery);